<div class="modal" [ngClass]="{ 'is-active': open }">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 1100px; max-width: 90%">
    <header class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="TEST_TEMPLATE"
      >
        {{ 'TEST_TEMPLATE' | translate }}
      </span>
      <button
        class="delete"
        aria-label="close"
        (click)="onClose.emit()"
      ></button>
    </header>
    <section
      class="modal-card-body"
      style="
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        min-height: 300px;
        max-height: 80vh;
      "
    >
      <form autocomplete="off" class="form columns mb-0">
        <div class="column is-3">
          <div class="field is-narrow">
            <label class="label" translationEditableDirective="TEMPLATE_TYPE">{{
              'TEMPLATE_TYPE' | translate
            }}</label>
            <div class="control">
              <ng-select
                [translationEditableModalDirective]="[
                  'RDN_TEMPLATE',
                  'BUSINESS_TEMPLATE',
                  'COMPOUND_TEMPLATE'
                ]"
                [items]="templates"
                name="template"
                [multiple]="false"
                [closeOnSelect]="true"
                bindLabel="title"
                bindValue="name"
                (change)="onTemplateChange($event)"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="column is-3">
          <div class="field is-narrow" *ngIf="selectedTemplate === 'RDN'">
            <label class="label" translationEditableDirective="PROPERTY_CODE">{{
              'PROPERTY_CODE' | translate
            }}</label>
            <div class="control">
              <ng-select
                [items]="propertiesOptions"
                [multiple]="false"
                [closeOnSelect]="true"
                (change)="onPropertyChange($event)"
                bindLabel="name"
                bindValue="id"
                [typeahead]="onPropertyAutocomplete$"
              >
              </ng-select>
            </div>
          </div>

          <div class="field is-narrow" *ngIf="selectedTemplate === 'BUSINESS'">
            <label class="label" translationEditableDirective="BUSINESS_CODE">{{
              'BUSINESS_CODE' | translate
            }}</label>
            <div class="control">
              <ng-select
                [items]="propertiesOptions"
                [multiple]="false"
                [closeOnSelect]="true"
                (change)="selectedBusiness = $event?.id"
                bindLabel="name"
                bindValue="id"
                [typeahead]="onBusinessAutocomplete$"
              >
              </ng-select>
            </div>
          </div>

          <div class="field is-narrow" *ngIf="selectedTemplate === 'COMPOUND'">
            <label class="label" translationEditableDirective="COMPOUND_CODE">{{
              'COMPOUND_CODE' | translate
            }}</label>
            <div class="control">
              <ng-select
                [items]="compoundsOptions"
                [multiple]="false"
                [closeOnSelect]="true"
                (change)="selectedCompound = $event?.id"
                bindLabel="name"
                bindValue="id"
                [typeahead]="onCompoundAutocomplete$"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="column is-3" *ngIf="selectedProperty">
          <div class="field is-narrow">
            <label class="label" translationEditableDirective="PROPERTY_TYPE">{{
              'PROPERTY_TYPE' | translate
            }}</label>
            <div class="control">
              <ng-select
                [items]="propertyTypeOptions"
                [multiple]="false"
                [closeOnSelect]="true"
                (change)="selectedPropertyType = $event?.id"
                bindLabel="name"
                bindValue="id"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="column is-3" *ngIf="showFileField">
          <div class="field is-narrow">
            <label class="label" translationEditableDirective="TEMPLATE">{{
              'TEMPLATE' | translate
            }}</label>
            <div class="control">
              <input
                class="input"
                type="file"
                accept="application/msword,.doc, .docx"
                (change)="handleFileChange($event)"
              />
            </div>
          </div>
        </div>
      </form>
      <div class="field is-grouped mb-6">
        <div class="control">
          <button
            [disabled]="isLoading || !showFileField || !templateFile"
            type="submit"
            class="button is-link"
            translationEditableDirective="SUBMIT"
            (click)="onSubmit()"
          >
            {{ 'SUBMIT' | translate }}
          </button>
        </div>
      </div>
      <h4 *ngIf="!!blob" translationEditableDirective="PREVIEW">
        {{ 'PREVIEW' | translate }}
      </h4>
      <ngx-extended-pdf-viewer
        *ngIf="!!blob"
        [src]="blob"
        useBrowserLocale="false"
        height="80vh"
        [showSidebarButton]="false"
        [showDrawEditor]="false"
        [showHighlightEditor]="false"
        [showOpenFileButton]="false"
        [showStampEditor]="false"
        [showTextEditor]="false"
        [showToolbar]="false"
      ></ngx-extended-pdf-viewer>
    </section>
  </div>
</div>
